export enum EMerchandisingReports {
  ChannelStats = "channel_stats",
  DealRatings = "deal_ratings",
  PreShootReport = "pre_shoot_report",
  TipReport = "tip_report",
}
